import { arrays } from './arrays';

const EMPRESAS_POR_CODIGO = new Map(
  arrays.Empresas.map(({ value, text }) => [value, text])
);

export const utils = {
  buscaEPCodigo(store) {
    return store.getters.user?.empresaLogada;
  },

  buscaNomeEmpresa(store) {
    const epCodigo = this.buscaEPCodigo(store);
    return EMPRESAS_POR_CODIGO.get(epCodigo) ?? 'Empresa não identificada';
  },

  async salvarSessaoAutenticada({
    api,
    store,
    dadosToken,
    identificador,
    empresaLogada
  }) {
    const tokenNormalizado = {
      ...dadosToken,
      expires: dadosToken.expiresIn ?? dadosToken.expires
    };

    try {
      const usuarioRegistrado = api.UTIL.Auth.RegisterToken(
        tokenNormalizado,
        identificador
      );

      if (!usuarioRegistrado) {
        return null;
      }

      const usuario = {
        ...usuarioRegistrado,
        identificador,
        empresaLogada
      };

      await store.dispatch('setUserData', { user: usuario });
      return usuario;
    } catch {
      api.UI.ShowError('Erro', 'Não foi possível atualizar a sessão');
      setTimeout(store.dispatch('logout'), 3000);
    }
  },

  getStatusEnvio(status) {
    const statuses = {
      0: 'Aguardando Envio',
      1: 'Enviado',
      2: 'Em Processamento no Bacen',
      3: 'Aceito',
      4: 'Rejeitado',
      5: 'Falha no Envio',
      6: 'Reenviado'
    };

    return statuses[status] ?? 'Desconhecido';
  },

  getStatusRecebimento(status) {
    const statuses = {
      1: 'Pendente',
      2: 'Recebido',
      3: 'Finalizado',
      4: 'ErroRecebimento'
    };

    return statuses[status] ?? 'Desconhecido';
  },

  getCorStatusEnvio(status) {
    switch (status) {
      case 3:
        return 'success';
      case 4:
      case 5:
        return 'error';
      default:
        return 'primary';
    }
  },

  getIconStatusEnvio(status) {
    switch (status) {
      case 3:
        return 'fas fa-check-circle';
      default:
        return 'fas fa-exclamation-circle';
    }
  }
};
